// extracted by css-extract-rspack-plugin
export default {"link":"Link_link__-Wlsf","link__body":"Link_link__body__row1X"};